import { createContext, useContext } from 'react';

/**
 * Bridges the Travel save layer across the Main ↔ TravelMapShell split.
 *
 * Main owns the region selection (`mapType`, e.g. 'usa') and the reopen payload
 * (it sets `mapType` so the right section mounts). TravelMapShell owns the
 * visited list, colour and stats config. Rather than thread save props through
 * all ~24 region section components, Main provides this context around the
 * travel tab and TravelMapShell consumes it.
 *
 * Value shape:
 *   {
 *     regionKey: string,        // Main's mapType — the saved region identifier
 *     regionLabel: string,      // human label for the breadcrumb (e.g. 'USA States')
 *     reopen: { id, name, settings } | null,  // pending restore, consumed once
 *     consumeReopen: () => void,
 *     openMap: { id, name } | null,
 *     setOpenMap: (m) => void,
 *     onStatus: (message, variant) => void,
 *   }
 */
const TravelSaveContext = createContext(null);

export const useTravelSave = () => useContext(TravelSaveContext);

export default TravelSaveContext;
